import React, { useState } from "react";
import { X } from "lucide-react";

export const InfoPage1 = ({onClose,title,description,img}) => {


  return (
    <div className="main overflow-hidden h-screen">
        <div className="billing dashboard bg-gradient-to-br mt-[16px] from-blue-500 via-blue-600 to-purple-700 h-[calc(100vh-122px)] overflow-auto relative">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-6 right-6 z-10 bg-white/20 hover:bg-white/30 rounded-full p-3 transition-all duration-200 group backdrop-blur-sm border border-white/20"
            aria-label="Close banner"
          >
            <X className="w-6 h-6 text-white group-hover:scale-110 transition-transform" />
          </button>

          {/* Main Content */}
          <div className="h-full flex items-center justify-center p-8 md:p-12 lg:p-10">
            <div className="max-w-7xl w-full mx-auto">
              <div className="flex flex-col lg:flex-row items-center justify-center gap-12 lg:gap-16 h-full">
                {/* Text Content */}
                <div className="flex-1 text-center lg:text-left max-w-2xl">
                  <h1 className="text-3xl md:text-4xl lg:text-7xl font-bold text-white mb-10 lg:mb-12 leading-tight">
                    Welcome to {title}
                  </h1>

                  <p className="text-blue-100 text-lg md:text-xl leading-relaxed mb-8 lg:mb-10">
                   {description}
                  </p>

                  <div className="flex justify-center lg:justify-start">
                    <button className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold hover:bg-blue-50 transition-all duration-300 shadow-2xl hover:scale-105">
                      Get Started
                    </button>
                  </div>
                </div>

                {/* Image */}
                <div className="flex-shrink-0 max-w-md lg:max-w-lg">
                  <div className="relative">
                    <img
                      src={img}
                      alt="Platform Preview"
                      className="w-full h-64 md:h-80 lg:h-40 xl:h-full 2xl:h-full object-cover rounded-2xl shadow-2xl"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};
